import { FlutedGlass } from "@paper-design/shaders-react";
import {
  useMotionValue,
  useMotionValueEvent,
  useSpring,
} from "motion/react";
import { useEffect, useState, type MouseEvent } from "react";

export function PaperShaderPage() {
  const [shift, setShift] = useState(0);
  const shiftTarget = useMotionValue(0);
  const shiftSpring = useSpring(shiftTarget, {
    stiffness: 120,
    damping: 20,
    mass: 0.35,
  });

  useMotionValueEvent(shiftSpring, "change", latest => {
    setShift(latest);
  });

  useEffect(() => {
    document.title = "Paper Design | Yash Bindal";

    const descriptionTag =
      document.querySelector('meta[name="description"]') ?? document.createElement("meta");

    descriptionTag.setAttribute("name", "description");
    descriptionTag.setAttribute("content", "A paper designed shader built with Paper x React");

    if (!descriptionTag.parentElement) {
      document.head.appendChild(descriptionTag);
    }
  }, []);

  const handleMouseMove = (event: MouseEvent<HTMLDivElement>) => {
    const currentTarget = event.currentTarget;
    const rect = currentTarget.getBoundingClientRect();

    const relativeX = event.clientX - rect.left;
    shiftTarget.set(1 - relativeX / rect.width);
  };

  return (
    <div className="container mx-auto flex min-h-screen max-w-2xl flex-col items-stretch justify-center gap-12 px-4 py-20 sm:px-6 sm:py-40">
      <div className="flex flex-col items-start gap-1">
        <h1 className="text-xl font-medium">Paper Design</h1>
        <h4 className="font-light text-neutral-500">A Paper designed shader built with Paper x React</h4>
      </div>

      <div
        className="overflow-hidden rounded-xl border border-solid bg-white dark:bg-neutral-800"
        style={{ borderColor: "rgb(var(--border-color))" }}
      >
        <div
          className="h-full min-h-80 w-full"
          role="img"
          aria-label="Paper shader visual"
          onMouseMove={handleMouseMove}
        >
          <FlutedGlass
            image="https://paper.design/flowers.webp"
            colorBack="rgba(0,0,0,0)"
            colorShadow="rgba(0,0,0,1)"
            colorHighlight="rgba(255,255,255,1)"
            size={0.5}
            shadows={0.25}
            highlights={0.1}
            shape="lines"
            angle={0}
            distortion={0.5}
            distortionShape="prism"
            shift={shift}
            stretch={0}
            blur={0}
            edges={0.25}
            marginLeft={0}
            marginRight={0}
            marginTop={0}
            marginBottom={0}
            grainMixer={0}
            grainOverlay={0}
            scale={1.1}
            fit="cover"
            originX={0.5}
            originY={0.5}
            offsetX={0}
            offsetY={0}
            rotation={0}
            speed={0}
            className="h-full min-h-80 w-full"
          />
        </div>
      </div>
    </div>
  );
}
